import { useGetMainList } from "ra-core";
import { FC, createContext, useContext, useMemo } from "react";
import { RecPatch } from "@/dataProvider/tools";
import { InfoTypeResponseDto } from "@/gen/api/secureai";
import { pages, sorts } from "@/utils/paramsWithGetMainList";

export interface SecAIInfoTypeDataContextProps {
  infoTypes: InfoTypeResponseDto[];
}

export const SecAIInfoTypeDataContext = createContext<SecAIInfoTypeDataContextProps>({} as any)

export const SecAIInfoTypeDataContextProvider : FC = ({ children }) => {
  const { data: infoTypesData, ids: ids1 } = useGetMainList<InfoTypeResponseDto&RecPatch>('settings/secureai/info-types', pages(), sorts(), {}, { action: 'CUSTOM_DATA_QUERY'})
  const val = useMemo(() => ({
    infoTypes: (ids1 ?? []).map((i) => infoTypesData![i]).sort((l, r) => {
      if (l.name! > r.name!) {
        return 1
      } else {
        return 0
      }
    }),
  }), [infoTypesData, ids1])
  return (
    <SecAIInfoTypeDataContext.Provider value={val}>
      {children}
    </SecAIInfoTypeDataContext.Provider>
  )
}

export const useSecAIInfoTypeDataContext = () => useContext(SecAIInfoTypeDataContext);